import moment from 'moment'
import * as log from 'loglevel'
/**
 * Migration for indexedDB
 * @param {Object} db - indexedDB instance
 */
export const MIGRATION = db => {
  db.version(1.2)
    .stores({
      chunks: 'id,chunk',
      pages: 'id,page',
      notifications:
        'id, userId, message, title, eventType, createdAt, eventUser, redirect'
    })
    .upgrade(trans => {
      log.info('Start indexed database migration.')
      return trans.notifications.toCollection().modify((notification, ref) => {
        if (!notification.eventType) {
          delete ref.value
        }
        const eventUser = Object.assign({}, notification.user)
        notification.eventUser = eventUser
        delete notification.user
        delete notification.type
      })
    })
  db.version(1.1).stores({
    chunks: 'id,chunk',
    pages: 'id,page',
    notifications: 'id, userId, message, title, type, createdAt, redirect'
  })
  db.version(1).stores({
    chunks: 'id,chunk',
    pages: 'id,page'
  })
}

export const INSERT_NOTIFICATION = async (db, data) => {
  const { userId, message, id } = data
  const { content, createdAt, events, title } = message
  const { payload, eventType } = events[0]
  const { user } = payload
  const pageId = payload.chunk.root ? payload.chunk.root.id : payload.chunk.id
  const redirect = {
    name: 'problemPage',
    params: {
      id: pageId
    }
  }
  const record = {
    createdAt: moment(createdAt).valueOf(),
    id,
    message: content,
    redirect,
    title,
    eventType,
    eventUser: user,
    userId
  }
  await db.notifications.put(record)
}
